module.exports = __webpack_public_path__ + "static/img/info.534bc24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/info.png
// module id = 3hnx
// module chunks = 0